import styled from 'styled-components'

export const Content = styled.div`
	max-width: 1200px;
	width: 100%;
	height: 100%;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
`
